import { Box, Button, Typography } from "@mui/material";
import React from "react";
import FoodImage from "../../../assets/foodImage.jpg";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useNavigate } from "react-router-dom";

export default function Header({
  pageTitle,
  handleCancle,
  handleSave,
  buttonName,
  loading,
  currentRoute,
  buttonShow,
  storeData,
  id,
}) {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        height: "80px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "4px",
        }}
      >
        {storeData?.image ? (
          <Box>
            <img
              src={storeData?.image}
              alt={storeData?.storeName}
              width="56px"
              height="56px"
              style={{
                borderRadius: "6px",
              }}
            />
          </Box>
        ) : (
          <div
            style={{
              width: "56px",
              height: "56px",
              borderRadius: "4px",
              backgroundColor: "#8770DE",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              color: "#fff",
              fontSize: "20px",
            }}
          >
            {storeData?.storeName?.charAt(0).toUpperCase()}
          </div>
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginLeft: "16px",
          }}
        >
          <Box>
            <label
              style={{
                textAlign: "left",
                fontSize: " 20px",
                fontWeight: 700,
              }}
            >
              {storeData?.storeName}
            </label>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              textAlign: "left",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
              {storeData?.storeCity}
            </Typography>
            <Typography>
              <FiberManualRecordIcon
                sx={{ width: "7px", height: "7px", marginLeft: "8px" }}
              />
            </Typography>
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                marginLeft: "8px",
                fontSize: "12px",
                fontWeight: 500,
              }}
            >
              <LocationOnIcon
                sx={{ color: "gray", width: "16px", height: "16px" }}
              />
              {storeData?.storeLocation}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box>
        <Button
          variant="contained"
          sx={{
            color: "rgba(28, 38, 48, 1)",
            height: "42px",
            border: "1px solid rgba(229, 229, 232, 1)",
            fontWeight: 600,
            fontSize: "14px",
            backgroundColor: "white",
            boxShadow: "none",
            ":hover": {
              backgroundColor: "white",
            },
          }}
          onClick={() => {
            navigate("/shopping/store/edit", {
              state: { id: id },
            });
          }}
        >
          Edit Store
        </Button>
      </Box>
    </Box>
  );
}
